import Vue from 'vue'

const state = {
  listaAtendimentos: [],
  atendimento: [],
  justificativas: [],
  motivos: [],
  motivosRemocao: [],
  motivosRemocaoBeneficiaria: [],
  motivosDesistenciaVoluntario: [],
  motivosDesistenciaBeneficiaria: []
}

const mutations = {
  setAtendimentos (state, data) {
    state.listaAtendimentos = data
  },
  setAtendimento (state, data) {
    state.atendimento = data
  },
  setJustificativas (state, data) {
    state.justificativas = data
  },
  setMotivos (state, data) {
    state.motivos = data
  },
  setMotivosRemocaoVinculo (state, data) {
    state.motivosRemocao = data
  },
  setMotivosRemocaoVinculoBeneficiaria (state, data) {
    state.motivosRemocaoBeneficiaria = data
  },
  setMotivosDesistenciaVoluntario (state, data) {
    state.motivosDesistenciaVoluntario = data
  },
  setMotivosDesistenciaBeneficiaria (state, data) {
    state.motivosDesistenciaBeneficiaria = data
  }
}

const actions = {
  buscarAtendimentos (context, config) {
    if (!config.page) {
      config.page = 1
    }

    if (!config.limit) {
      config.limit = 200
    }

    Vue.http.get('api/atendimento/meusAtendimentos?length=' + config.limit + '&page=' + config.page).then(response => {
      context.commit('setAtendimentos', response.body.data.data)
    })
  },
  buscaAtendimento (context, id) {
    Vue.http.get('api/atendimento/' + id).then(response => {
      context.commit('setAtendimento', response.body.data)
    })
  },
  buscarJustificativas (context) {
    Vue.http.get('api/justificativas-cancelamento').then(response => {
      context.commit('setJustificativas', response.data.data)
    })
  },
  buscarJustificativasBeneficiaria (context) {
    Vue.http.get('api/justificativas-cancelamento-beneficiaria').then(response => {
      context.commit('setJustificativas', response.data.data)
    })
  },
  buscarMotivos (context) {
    Vue.http.get('api/motivos-cancelamento').then(response => {
      context.commit('setMotivos', response.data.data)
    })
  },
  buscarMotivosRemocaoVinculo (context) {
    Vue.http.get('api/motivos-remocao-vinculo').then(response => {
      context.commit('setMotivosRemocaoVinculo', response.data.data)
    })
  },
  buscarMotivosBeneficiaria (context) {
    Vue.http.get('api/motivos-remocao-vinculo-beneficiaria').then(response => {
      context.commit('setMotivosRemocaoVinculoBeneficiaria', response.data.data)
    })
  },
  buscarMotivosDesistenciaVoluntario (context) {
    Vue.http.get('api/motivos-desistencia-voluntario').then(response => {
      context.commit('setMotivosDesistenciaVoluntario', response.data.data)
    })
  },
  buscarMotivosDesistenciaBeneficiaria (context) {
    Vue.http.get('api/motivos-desistencia-beneficiaria').then(response => {
      context.commit('setMotivosDesistenciaBeneficiaria', response.data.data)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/atendimento.js